var map = {
	"./saffronfiles/assets/frameworks/we.js": 41398,
	"./saffronfiles/assets/frameworks/we/saffronAdapter.js": 71225,
	"./saffronfiles/assets/frameworks/we/we.js": 4721,
	"./saffronfiles/config/modules/locale.js": 94145,
	"./saffronfiles/config/modules/router.js": 25591,
	"./saffronfiles/config/modules/style.js": 39244,
	"./saffronfiles/config/modules/user.js": 88050,
	"./saffronfiles/config/root.js": 32289,
	"./saffronfiles/extensions/validation/validatorFactories/availableOnRemote.js": 24505,
	"./saffronfiles/extensions/validation/validators/anyI18nPhoneNumber.js": 78138,
	"./saffronfiles/extensions/validation/validators/cleanIsraelyMobilePhoneNumber.js": 46865,
	"./saffronfiles/extensions/validation/validators/goodPassword.js": 73010,
	"./saffronfiles/extensions/validation/validators/i18nPhoneNumber.js": 20895,
	"./saffronfiles/extensions/validation/validators/i18nPhoneNumberObject.js": 39039,
	"./saffronfiles/extensions/validation/validators/israelyPersonalId.js": 99037,
	"./saffronfiles/extensions/validation/validators/urlSafeString.js": 84838,
	"./saffronfiles/locale/en-US/locale.js": 99514,
	"./saffronfiles/locale/en-US/messages.js": 28409,
	"./saffronfiles/locale/he-IL/locale.js": 85543,
	"./saffronfiles/locale/he-IL/messages.js": 19961,
	"./saffronfiles/pwaConfig.js": 72202,
	"./saffronfiles/saffronfiles.js": 11206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58776;